module.exports = __webpack_public_path__ + "img/404_992.0c54ed0f.png";